import React, { useState } from 'react'
import GateBanner from './GateBanner'
import 'templates/ScrollingSponsoredTemplate/ScrollingSponsoredTemplate.scss'

import { Button, TextField } from '@mui/material'

// Constants for default values
const DEFAULT_AGE_GATE_TITLE = 'Are you 21 or older?'
const DEFAULT_AGE_GATE_COPY =
  'Now, wait just a minute—enter your birthdate below to confirm you are 21 or older to continue. You must be of legal drinking age in order to view this content.'
const DEFAULT_FAILED_TITLE = 'You must be 21 or older to view this content'
const DEFAULT_FAILED_COPY =
  'Unfortunately, you’re not of age to view this break, but why don’t you check out some other content we think you’d enjoy?'
const DEFAULT_FAILED_BUTTON_URL = '/'
const DEFAULT_FAILED_BUTTON_COPY = 'Back to Homepage'
const DEFAULT_OVER_MAX_TITLE = 'You must be younger to view this content'
const DEFAULT_OVER_MAX_COPY =
  "Unfortunately, you're too old to view this break, but why don't you check out some other content we think you'd enjoy?"

export function AgeTargetingBanner({ brk, setStepLocked }) {
  const {
    ageGateTitle = DEFAULT_AGE_GATE_TITLE,
    ageGateBackgroundImageId,
    ageGateCopy = DEFAULT_AGE_GATE_COPY,
    ageGateFailedTitle = DEFAULT_FAILED_TITLE,
    ageGateFailedCopy = DEFAULT_FAILED_COPY,
    ageGateFailedButtonUrl = DEFAULT_FAILED_BUTTON_URL,
    ageGateFailedButtonCopy = DEFAULT_FAILED_BUTTON_COPY,
    ageGateMobileBackgroundImageId,
  } = brk
  const [birthdate, setBirthdate] = useState('')
  const [ageGateError, setAgeGateError] = useState(false)
  const [ageGateState, setAgeGateState] = useState('ask')

  const defaultButton = (url, copy) => (
    <a className="btn herobtn themed-button" id="backtohomepage" href={url}>
      {copy}
    </a>
  )

  const calculateDateOfBirth = () => {
    let minAge = brk.ageGate.min
    let maxAge = brk.ageGate.max
    let dob = Date.parse(birthdate)
    let diff = new Date(new Date() - dob)
    let age = diff.getFullYear() - 1970

    if (age >= minAge && age <= maxAge) {
      setAgeGateState('over21')
      setStepLocked()
    } else if (age < minAge) {
      setAgeGateState('under21')
    } else if (age > maxAge) {
      setAgeGateState('overMax')
    }
  }

  // if valid, returns false (no errors)
  // if not valid, returns true (errors present)
  // probably could adjust the language around this
  const validateDOB = () => {
    const pattern = /^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})$/
    if (pattern.test(birthdate)) {
      return false
    } else {
      return true
    }
  }

  const errorHelperText = 'Enter birthdate in the mm/dd/yyyy format please'

  const handleAgeGateFormSubmit = () => {
    calculateDateOfBirth()
    setAgeGateError(validateDOB())
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const buttonValidationClass = validateDOB() ? 'invalid' : 'valid'

  const ageGateForm = (
    <div>
      <TextField
        name="Birthdate"
        label="Birthdate* (mm/dd/yyyy)"
        variant="filled"
        id="dateofbirth"
        value={birthdate}
        onChange={e => {
          setBirthdate(e.target.value)
        }}
        error={ageGateError}
        helperText={brk.ageGate.errorHelperText && errorHelperText}
      />
      <Button
        className={`btn herobtn themed-button ${buttonValidationClass}`}
        onClick={handleAgeGateFormSubmit}
        id="submitdob"
      >
        Submit
      </Button>
    </div>
  )

  const ageGateContent = {
    ask: {
      title: ageGateTitle,
      text: ageGateCopy,
      button: ageGateForm,
    },
    under21: {
      title: ageGateFailedTitle,
      text: ageGateFailedCopy,
      button: defaultButton(ageGateFailedButtonUrl, ageGateFailedButtonCopy),
    },
    overMax: {
      title: DEFAULT_OVER_MAX_TITLE,
      text: DEFAULT_OVER_MAX_COPY,
      button: defaultButton(DEFAULT_FAILED_BUTTON_URL, 'Back to Homepage'),
    },
  }

  const getGateBannerProps = ageState => {
    const backgroundImageUrl = ageGateBackgroundImageId
      ? `${process.env.SITE_ASSET_URL}/${ageGateBackgroundImageId}`
      : null
    const mobileBackgroundImageUrl = ageGateMobileBackgroundImageId
      ? `${process.env.SITE_ASSET_URL}/${ageGateMobileBackgroundImageId}`
      : null

    return {
      ...ageGateContent[ageState],
      backgroundImageUrl,
      mobileBackgroundImageUrl,
    }
  }

  const gateBannerProps = getGateBannerProps(ageGateState)

  return <GateBanner {...gateBannerProps} />
}
